import { compatWrapper } from '@backstage/core-compat-api';

import {
  createFrontendPlugin,
  FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isAksKubeloginCardAvailable } from './components/AksKubeloginCard/AksKubeloginCard';

// Create EntityCardBlueprint for the connection card
const entityAKSKubeloginCard = EntityCardBlueprint.make({
  name: 'connect',
  params: {
    // Define content type to render it on the main container
    type: 'content',
    // Define filter to only render on kubernetes-cluster resources
    filter: isAksKubeloginCardAvailable,
    loader: () =>
      import('./components/AksKubeloginCard').then(m =>
        compatWrapper(<m.AksKubeloginCard />),
      ),
  },
});

export const aksKubeloginPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'aks-kubelogin',
  info: {
    // Load plugin info from package json
    packageJson: () => import('../package.json'),
    // Load manifest info from catalog-info
    manifest: () => import('../catalog-info.yaml'),
  },
  // bind all the extensions to the plugin
  extensions: [entityAKSKubeloginCard],
});
